import * as React from 'react';
import styled from 'styled-components';

import { CheckIcon } from '../../components/Icons';

interface IProps {
  'data-testhook'?: string;
  checked: boolean;
  className?: string;
  helpMessage?: string;
  label: string;
  name: string;
  onChange?: (e: React.ChangeEvent<React.ReactNode>) => void;
}

const defaultProps = {};

export class CheckboxBase extends React.Component<IProps, {}> {
  public static defaultProps = defaultProps;

  public render() {
    const {
      className,
      onChange,
      checked,
      helpMessage,
      label,
      'data-testhook': dataTesthook,
    } = this.props;

    return (
      <div className={className}>
        <label className="Checkbox__label" data-testhook={dataTesthook} data-id={dataTesthook}>
          <span className="Checkbox__box">
            {checked ? <CheckIcon className="Checkbox__icon" /> : null}
          </span>
          {label}
          <input
            className="Checkbox__input"
            type="checkbox"
            onChange={onChange}
            checked={checked}
          />
        </label>
        {helpMessage && <div className="Checkbox__help-message">{helpMessage}</div>}
      </div>
    );
  }
}

export default styled(CheckboxBase)`
  margin: 12px 0;

  .Checkbox__label {
    position: relative;
    display: flex;
    flex-direction: row;
    align-items: center;
    font-size: 1.4rem;
  }

  .Checkbox__box {
    border: 1px solid ${(p) => p.theme.colors.grey500};
    width: 24px;
    height: 24px;
    display: flex;
    margin: 0 12px 0 0;
    justify-content: center;
    align-items: center;
  }

  .Checkbox__input {
    display: none;
    opacity: 0;
    visibility: hidden;
  }

  .Checkbox__icon {
    fill: ${(p) => p.theme.colors.grey50};
  }

  .Checkbox__help-message {
    margin-left: 36px;
    font-size: 1.2rem;
    margin-top: 12px;
    color: ${(p) => p.theme.colors.grey700};
  }
`;
